import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './NewsSection.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }).toUpperCase();
}

export default function NewsSection({ eyebrow = 'Update', title = 'Berita Terbaru' }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/news/public?limit=3`)
      .then((res) => {
        if (mounted) setNews(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setNews([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loading && news.length === 0) return null;

  return (
    <div className="news-section">
      <div className="news-inner">
        <div className="news-header">
          <div>
            <span className="news-eyebrow">{eyebrow}</span>
            <h2 className="news-title-main">{title}</h2>
          </div>
          <a href="/news" className="section-link">Semua Berita →</a>
        </div>

        {loading ? (
          <div className="news-empty">Memuat berita...</div>
        ) : (
          <div className="news-row">
            {news.map((n) => (
              <a href={`/news/${n.slug}`} className="news-card" key={n.id}>
                <div className="news-date">{formatDate(n.published_at)}</div>
                <div className="news-headline">{n.title}</div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
